var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.447
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_635",
    "data-name": "Ellipse 635",
    cx: 56,
    cy: 56,
    r: 56,
    transform: "translate(-11068.963 -24841.963)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.5,
    cy: 0.5,
    r: 0.54,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0070b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0070b6",
    stopOpacity: 0.082
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6261",
    "data-name": "Group 6261",
    transform: "translate(1157 -4277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_36",
    "data-name": "Mask Group 36",
    transform: "translate(9911.963 29118.963)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Dot_Pattern-Small",
    "data-name": "Dot Pattern-Small",
    d: "M165.354,252.724a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,165.354,252.724Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,153.941,252.724Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,142.527,252.724Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,131.113,252.724Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,119.7,252.724Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,108.286,252.724Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,96.872,252.724Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,85.458,252.724Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,74.044,252.724Zm-11.414,0A1.631,1.631,0,1,1,61,254.354,1.631,1.631,0,0,1,62.631,252.724ZM165.354,241.31a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,165.354,241.31Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,153.941,241.31Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,142.527,241.31Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,131.113,241.31Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,119.7,241.31Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,108.286,241.31Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,96.872,241.31Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,85.458,241.31Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,74.044,241.31Zm-11.414,0A1.631,1.631,0,1,1,61,242.941,1.631,1.631,0,0,1,62.631,241.31ZM165.354,229.9a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,165.354,229.9Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,153.941,229.9Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,142.527,229.9Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,131.113,229.9Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,119.7,229.9Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,108.286,229.9Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,96.872,229.9Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,85.458,229.9Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,74.044,229.9Zm-11.414,0A1.631,1.631,0,1,1,61,231.527,1.631,1.631,0,0,1,62.631,229.9Zm102.724-11.414a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,165.354,218.482Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,153.941,218.482Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,142.527,218.482Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,131.113,218.482Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,119.7,218.482Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,108.286,218.482Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,96.872,218.482Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,85.458,218.482Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,74.044,218.482Zm-11.414,0A1.631,1.631,0,1,1,61,220.113,1.631,1.631,0,0,1,62.631,218.482Zm102.724-11.414a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,165.354,207.069Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,153.941,207.069Zm-11.414,0A1.631,1.631,0,1,1,140.9,208.7,1.631,1.631,0,0,1,142.527,207.069Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,131.113,207.069Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,119.7,207.069Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,108.286,207.069Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,96.872,207.069Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,85.458,207.069Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,74.044,207.069Zm-11.414,0A1.631,1.631,0,1,1,61,208.7,1.631,1.631,0,0,1,62.631,207.069Zm102.724-11.414a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,165.354,195.655Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,153.941,195.655Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,142.527,195.655Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,131.113,195.655Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,119.7,195.655Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,108.286,195.655Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,96.872,195.655Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,85.458,195.655Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,74.044,195.655Zm-11.414,0A1.631,1.631,0,1,1,61,197.286,1.631,1.631,0,0,1,62.631,195.655Zm102.724-11.414a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,165.354,184.241Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,153.941,184.241Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,142.527,184.241Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,131.113,184.241Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,119.7,184.241Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,108.286,184.241Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,96.872,184.241Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,85.458,184.241Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,74.044,184.241Zm-11.414,0A1.631,1.631,0,1,1,61,185.872,1.631,1.631,0,0,1,62.631,184.241Zm102.724-11.414a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,165.354,172.827Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,153.941,172.827Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,142.527,172.827Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,131.113,172.827Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,119.7,172.827Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,108.286,172.827Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,96.872,172.827Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,85.458,172.827Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,74.044,172.827Zm-11.414,0A1.631,1.631,0,1,1,61,174.458,1.631,1.631,0,0,1,62.631,172.827Zm102.724-11.414a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,165.354,161.414Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,153.941,161.414Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,142.527,161.414Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,131.113,161.414Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,119.7,161.414Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,108.286,161.414Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,96.872,161.414Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,85.458,161.414Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,74.044,161.414Zm-11.414,0A1.631,1.631,0,1,1,61,163.044,1.631,1.631,0,0,1,62.631,161.414ZM165.354,150a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,165.354,150Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,153.941,150Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,142.527,150Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,131.113,150ZM119.7,150a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,119.7,150Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,108.286,150Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,96.872,150Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,85.458,150Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,74.044,150Zm-11.414,0A1.631,1.631,0,1,1,61,151.631,1.631,1.631,0,0,1,62.631,150Z",
    transform: "translate(-11127.139 -24988.914)",
    fillRule: "evenodd",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5763",
    "data-name": "Group 5763",
    transform: "translate(-8 -316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BG",
    transform: "translate(570 304)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5756",
    "data-name": "Group 5756"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_123",
    "data-name": "Ellipse 123",
    cx: 32,
    cy: 32,
    r: 32,
    transform: "translate(-1695 4313)",
    fill: "#0070b6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5594",
    "data-name": "Group 5594",
    transform: "translate(0 152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5753",
    "data-name": "Group 5753",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2049",
    "data-name": "Rectangle 2049",
    transform: "translate(-1109 4481)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 29,
    height: 29,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2052",
    "data-name": "Rectangle 2052",
    transform: "translate(-1109 4481)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 29,
    height: 29,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5754",
    "data-name": "Group 5754"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2053",
    "data-name": "Rectangle 2053",
    transform: "translate(-1111 4486)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 7,
    rx: 1.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    height: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2054",
    "data-name": "Rectangle 2054",
    transform: "translate(-1111 4501)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 7,
    rx: 1.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    height: 4,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_8",
    "data-name": "Subtraction 8",
    d: "M10600.322,27180.658a1.312,1.312,0,0,1-.942-.395l-2.006-2.006a5.336,5.336,0,0,1-5.43,0l-2.006,2.012a1.319,1.319,0,0,1-.942.389,1.333,1.333,0,0,1-.947-2.277l2.006-2.014a5.319,5.319,0,0,1,.007-5.422l-2.013-2.014a1.334,1.334,0,0,1,0-1.883,1.339,1.339,0,0,1,.947-.393,1.32,1.32,0,0,1,.942.393l2.013,2.006a5.348,5.348,0,0,1,5.423,0l2.006-2.006a1.32,1.32,0,0,1,.942-.393,1.338,1.338,0,0,1,.947,2.283l-2.013,2.006a5.328,5.328,0,0,1,.007,5.422l2.006,2.006a1.347,1.347,0,0,1,0,1.891A1.332,1.332,0,0,1,10600.322,27180.658Zm-5.663-9.672a2.67,2.67,0,1,0,2.674,2.666A2.669,2.669,0,0,0,10594.659,27170.986Z",
    transform: "translate(-11687.66 -22676.656)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVault);
export default __webpack_public_path__ + "static/media/vault.2287d9326b0f71cf032d5a4053e4bd44.svg";
export { ForwardRef as ReactComponent };